<div class="line-chart" [class.line-chart-bare]="!title">
  @if (title) {
    <div class="line-chart-head">
      <div class="line-chart-title">
        {{ title }}
        @if (info) {
          <app-info infoIndex="{{ info }}"></app-info>
        }
      </div>
    </div>
  }

  @if (loaded && internalReady()) {
    <highcharts-chart
      [options]="chartOptions"
      [constructorType]="chartConstructor"
      (chartInstance)="setChartInstance($event)"
      style="width: 100%; height: auto; display: block"
    ></highcharts-chart>
  } @else {
    <app-chart-placeholder></app-chart-placeholder>
  }
</div>
